import { Component, Input } from "@angular/core";
import { BannerSwiperConfiguration } from "../models/bannerSwiper-config.model";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper";
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);
@Component({
    selector: 'app-swiper-banner',
    templateUrl: './templates/swiperBanner.component.html'
})
export class SwiperBannerComponent {
    @Input()
    config!: BannerSwiperConfiguration;
}